import React from 'react';
//Components
import NormalEdit from './LlamadaNormalEdit';
import UbicacionEdit from './UbicacionEdit';
//Material-UI
import Divider from '@material-ui/core/Divider';

export default function TipoEdit() {
    return (
        <div className="tipo-step">
            <div className="tipo-step-config">
                <NormalEdit />
            </div>
            <Divider className="tipo-step-divider" />
            <div className="tipo-step-ubicacion">
                <p className="llamada-step-section-title">¿Desde dónde se puede levantar?</p>
                <UbicacionEdit />
            </div>
        </div>
    );
}
